module.exports = {"id":"193839","name":"Rômulo","rating":"76","photo":"./data/images/photos/3/193839.png","club":{"name":"Hellas Vérone","logo":"./data/images/clubs/HellasVerone.png"},"positions":["MD","DD","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Romulo0.json
// module id = 3707
// module chunks = 0